import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperOur = () => {
  new Swiper('.swiper-our', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 800,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: -6,
      },
      1440: {
        slidesPerView: 2.4,
      },
    },
  });
};

export default swiperOur;
